import React, { useEffect, useContext, useState,useMemo, useRef } from 'react'
import { $CommonServiceFn } from '../../components/network/Service';
import {$Service_Url,AoAdminBaseUrl,AoIntakeBaseUrl,AoPartnerBaseUrl,CounterBaseUrl} from '../../components/network/UrlPath';
import { UserContext } from '../../App';
import { useNavigate, useLocation } from 'react-router-dom';
import commonLib from '../../components/control/commonLib';
import konsole from '../../components/control/Konsole';
import LoaderScreen from './LoaderScreen';
import { getApiCall2, postApiCall } from '../../components/Reusable/ReusableCom';
import { getRoleIdOf, specialIPv4, nonOtpId } from '../../components/control/Constant';


function Redirect() {

  const {setLoader,setLoaderText,setcurMainImageNum} = useContext(UserContext);
  const { state } = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [selectedRolesData, setSelectedRolesData] = useState(null);
  const [showSelectedRolesModal, setShowSelectedRolesModal] = useState(false);
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);
  const otpReceived = state?.otpVerified ?? null;
  const [loaderscreenmodal, setLoaderscreenmodal] = useState(true);
  const [checkingconnection, setcheckingconnection] = useState(2);
  const [validateUserId, setValidateUserId] = useState(1);
  const [validateAuth0, setValidateAuth0] = useState(1);
  const [checkingmultirole, setcheckingmultirole] = useState(1);
  const [validaetsuccessfully, setvalidatesuccessfully] = useState(1);

  const [showModalMsgType, setShowModalMsgType] = useState(null);
  const [browserName, setBrowserName] = useState('');
  const [allUserData, setAllUserData] = useState();
  const [getIpaddress, setIpaddress] = useState('');

  const filteredAllRoles =  allUserData !== undefined && allUserData !== null &&  allUserData !== '' &&
  allUserData.filter(role => [3, 13, 14, 15, 6].includes(role.roleId));



  console.log("filteredAllRoles",state)

  useEffect(() => {
    setcurMainImageNum(0);
  }, [setcurMainImageNum]);

  // const fetchUserDetails = async (email) => {

  //   if (!email) {
  //     return;
  //   }

  //   const response = await getApiCall2('GET', `${$Service_Url.getLoginuserDetail}?emailId=${email}`);
  //   if (response && response.length > 0) {
  //     setUserDetails(response[0]);
  //   }
  // };

  const fetchUserDetails = async (email) => {
  if (!email) {
    return;
  }

  const response = await getApiCall2(
    "POST",
    $Service_Url.getLoginuserDetail,
    {
      emailId: email
    }
  );

  if (response && response.length > 0) {
    setUserDetails(response[0]);
  }
};






  const postSendOtpDetails = async (postDetails) => {
    const response = await postApiCall('POST', $Service_Url.postSendOtp,postDetails);
    return response;
  };


  const processUserDetails = async () => {

    const authToken = commonLib.getSessionStorage("AuthToken");
    if (!authToken) {
      navigate("/Account/SignIn", { replace: true });
      return;
    }
    const email = state?.userName || state?.email || state?.emailId
      // commonLib.getSessionStorage("LoginEmail");
    if (email) {
      await fetchUserDetails(email);
    }
  };

  useEffect(() => {
    getUserIPv4();
  }, []);


  // const getUserIPv4 = async () => {

  //   try {

  //     const url = $Service_Url.getIPv4;
  //     const result = await getApiCall2("GET", url);
  //     setIpaddress(result);
  //   } catch (error) {
  //     setIpaddress({
  //       ip: null
  //     });
  //   }
  // };

  const getUserIPv4 = async () => {
  try {
    const url = $Service_Url.getIPv4;
    const result = await getApiCall2("POST",url,{});
    setIpaddress(result);
  } catch (error) {
    setIpaddress({
      ip: null
    });
  }
};




  useEffect(() => {

    if (otpReceived === true) {
      return;
    }

    if (!userDetails) {
      return;
    }

    const postData = {
      createdBy: userDetails.userId,
      otpSendOn:`${userDetails.mobileNo?.split(',')[0]}|${userDetails.emailId}`,
      otpSendMedium: 4,
      resendCount: 0,
      otpType: 'TWOFACTORAUTHENTICATION'
    };

    // console.log("llllllllllllll",getIpaddress?.ip)
    if ([specialIPv4[0]?.value,specialIPv4[1]?.value,specialIPv4[2]?.value].includes(getIpaddress?.ip) || nonOtpId?.map(id => id.toLowerCase()).includes(userDetails?.userId?.toLowerCase()) ) {

      navigate("/Account/Redirect", {
        state: {
          otpVerified: true,
          userName: userDetails?.emailId,
          email: userDetails?.emailId,
          expiresIn: state?.expiresIn
        }
      });

      return;
    }
    postSendOtpDetails(postData).then((response) => {

        if (response && response?.data) {
          const Id = response.data.data.id;
          commonLib.resetSS4Otp();
          navigate(`/Account/verifyOtp`, {

            state: {
              createdBy: postData.createdBy,
              otpSendMedium: postData.otpSendMedium,
              otpSendOn:`${userDetails.mobileNo?.split(',')[0]}`,
              otpType: postData.otpType,
              resendCount:postData.resendCount,
              createId:postData.createdBy,
              expiresIn: state?.expiresIn,
              email: state?.email || userDetails?.emailId,
              Id: Id,
              senddata: {
                emailId: userDetails?.emailId || 'example@mail.com',
                mobileNumber: userDetails.mobileNo?.split(',')[0] || '+1234567890',
                phoneNo: userDetails.mobileNo?.split(',')[0] ||      '+1234567890'
              },
              typeOfPage: 'signIn'
            }
          });
        }

      }).catch((error) => {
      });

  }, [userDetails,otpReceived,getIpaddress]);


  /*
   * Staff login detection.
   */
  const isStaffLogin = useMemo(() => {

    return (
      window.location.pathname?.includes('Legal-staff') ||
      window.location.pathname?.includes('legal-staff')
    );

  }, []);

  useEffect(() => {

    if (getIpaddress === '') {
      return;
    }

    setLoader(false);

    setLoaderText('VALID_USER');

    redirectFunc(getIpaddress);

  }, [
    getIpaddress,
    otpReceived
  ]);


const redirectFunc = async (getIpaddress) => {

  const authToken =  commonLib.getSessionStorage("AuthToken");

  if (!authToken) {
    setLoader(false);
    setLoaderText('');
    navigate("/Account/SignIn", {
      replace: true
    });
    return;
  }

  if (
    otpReceived !== true &&
    !userDetails
  ) {

    await processUserDetails();

    return;
  }


  /*
   * Existing validation flow.
   */
  setTimeout(() => {

    setcheckingconnection(3);

    setValidateUserId(2);

    konsole.log(
      "New Login Token found"
    );


    getDeviceType((deviceType) => {

      konsole.log(
        'devtype',
        deviceType
      );


      if (!deviceType) {
        return;
      }


      setTimeout(() => {

        setValidateUserId(3);

        /*
         * Keeping this state because
         * LoaderScreen already uses it.
         */
        setValidateAuth0(2);


        detectBrowser((browserMode) => {

          if (!browserMode) {
            return;
          }


          setTimeout(async () => {

            setValidateAuth0(3);

            setcheckingmultirole(2);





            const authToken = commonLib.getSessionStorage("AuthToken");

if (!authToken) {
  console.error("AuthToken is missing");
  setLoader(false);
  navigate("/Account/SignIn", { replace: true });
  return;
}

const tokenPayload = decodeJwtPayload(authToken);

const authId = tokenPayload?.sub?.includes("|")
  ? tokenPayload.sub.split("|")[1]
  : tokenPayload?.sub || null;
const appState = crypto.randomUUID();
const inputData = {
  authId,
  appState: state?.appState || appState || null,
  expiresIn: state?.expiresIn ?? null,
  userName:
    tokenPayload?.email ||
    state?.userName ||
    state?.email ||
    state?.emailId ||
    userDetails?.emailId ||
    null,
  refereshToken: null,
  tokenType: "Bearer",
  clientIP: getIpaddress?.ip || "::1",
  deviceType,
  browseMode: browserMode,
  browseType: null
};






            setTimeout(() => {

              setcheckingmultirole(3);

              setvalidatesuccessfully(2);



              $CommonServiceFn.InvokeCommonApi(
                "POST",
                $Service_Url.postAuth0UserLogin,
                inputData,
                (response, errorData) => {


                  if (response) {

                    setLoader(false);


                    setTimeout(() => {

                      setvalidatesuccessfully(3);


                      if (
                        response.data?.data?.appState !== undefined &&
                        response.data.data.loggedInUserId !== undefined &&
                        response.data.data.roleId !== undefined
                      ) {

                        konsole.log(
                          "selected roles id ",
                          response
                        );


                        const appState =
                          response.data.data.appState;


                        const userId =
                          response.data.data.loggedInUserId;


                        const loggenInId =
                          response.data?.data?.logUserLoginId;


                        const selectedRolesArray =
                          response.data.data?.userRoles?.filter(
                            (v) =>
                              v?.roleId !== getRoleIdOf.enquiryMember &&
                              v?.roleId !== getRoleIdOf.surveyUser &&
                              v?.roleId !== getRoleIdOf.speaker &&
                              v?.roleId !== getRoleIdOf.planner &&
                              v?.roleId !== getRoleIdOf.notary
                          );


                        setAllUserData(
                          selectedRolesArray
                        );


                        if (
                          selectedRolesArray.length === 1
                        ) {



                          const selectedRoles =
                            selectedRolesArray[0];


                          const roleId =
                            selectedRoles.roleId;


                          const findArray =
                            selectedRolesArray.filter(
                              (data) =>
                                data.roleId !==
                                getRoleIdOf.legacyUser
                            );


                          const filteredRoles =
                            selectedRolesArray.filter(
                              role =>
                                [
                                  getRoleIdOf.paralegal,
                                  getRoleIdOf.attorney,
                                  getRoleIdOf.legalAssistant,
                                  getRoleIdOf.lawOfficeStaff
                                ].includes(role.roleId)
                            );


                          const otherLegalStaffs =
                            selectedRolesArray.filter(
                              role =>
                                [
                                  getRoleIdOf.platformAdministrator,
                                  getRoleIdOf.eventCoordinator,
                                  getRoleIdOf.firmAdministrator
                                ].includes(role.roleId)
                            );


                          const json = {

                            selectedRoles:
                              selectedRolesArray,

                            auhtenicateKeys: {

                              appState:
                                appState,

                              userId:
                                userId,

                              loggenInId:
                                loggenInId,

                              email:
                                response.data.data.userName,

                              memberName:
                                response.data.data.memberName
                            }
                          };


                          if (findArray.length > 0) {

                            if (
                              filteredRoles.length > 0 ||
                              otherLegalStaffs.length > 0
                            ) {

                              setLoaderscreenmodal(false);

                              setcurMainImageNum(2);


                              navigate(
                                `/Account/SelectRoles`,
                                {
                                  state: {
                                    selectedRolesData:
                                      json
                                  },
                                  replace: true
                                }
                              );

                            } else {

                              const finalRoleId =
                                (
                                  roleId ===
                                  getRoleIdOf.aoAcademyUsers ||
                                  roleId ===
                                  getRoleIdOf.aoAcademyUsers_18
                                )
                                  ? JSON.stringify(
                                      selectedRolesArray
                                    )
                                  : roleId;


                              const tokenKey =
                                `appState=${appState}` +
                                `&userId=${userId}` +
                                `&roleId=${finalRoleId}` +
                                `&loggenInId=${loggenInId}`;


                              konsole.log(
                                "show maess",
                                findArray,
                                tokenKey
                              );


                              commonLib.redirectToModule(
                                roleId,
                                tokenKey
                              );
                            }

                          } else {

                            const userPswd =
                              localStorage.getItem('|\/*P*/\|');


                            const tokenKey =
                              `appState=${appState}` +
                              `&userId=${userId}` +
                              `&roleId=${JSON.stringify(selectedRolesArray)}` +
                              `&loggenInId=${loggenInId}` +
                              `&Psw=${userPswd}`;


                            window.location.replace(
                              `${AoPartnerBaseUrl}login?token=${window.btoa(tokenKey)}`
                            );
                          }

                        } else {

                          const rolesData =
                            selectedRolesArray?.length > 0
                              ? selectedRolesArray
                              : response.data.data?.userRoles;


                          const json = {

                            selectedRoles:
                              rolesData,

                            auhtenicateKeys: {

                              appState:
                                appState,

                              userId:
                                userId,

                              loggenInId:
                                loggenInId,

                              email:
                                response.data.data.userName,

                              memberName:
                                response.data.data.memberName
                            }
                          };


                          const findArray =
                            selectedRolesArray.filter(
                              (data) =>
                                data.roleId !== 20
                            );


                          const checkForAcadAndLpo =
                            selectedRolesArray?.length === 2 &&
                            (
                              selectedRolesArray.some(
                                item =>
                                  item?.roleId === 17 ||
                                  item?.roleId === 18
                              ) &&
                              (
                                selectedRolesArray.some(
                                  item => item?.roleId === 9
                                ) ||
                                selectedRolesArray.some(
                                  item => item?.roleId === 1
                                ) ||
                                selectedRolesArray.some(
                                  item => item?.roleId === 10
                                )
                              )
                            );


                          const checkForAcadLpoAndAgent =
                            selectedRolesArray?.length === 3 &&
                            (
                              selectedRolesArray.some(
                                item =>
                                  item?.roleId === 17 ||
                                  item?.roleId === 18 ||
                                  item?.roleId === 5
                              )
                            ) &&
                            (
                              selectedRolesArray.some(
                                item => item?.roleId === 9
                              ) ||
                              selectedRolesArray.some(
                                item => item?.roleId === 1
                              ) ||
                              selectedRolesArray.some(
                                item => item?.roleId === 10
                              )
                            );


                          const checkForLpoAndAgent =
                            selectedRolesArray?.length === 2 &&
                            selectedRolesArray.some(
                              item => item?.roleId === 5
                            ) &&
                            (
                              selectedRolesArray.some(
                                item => item?.roleId === 9
                              ) ||
                              selectedRolesArray.some(
                                item => item?.roleId === 1
                              ) ||
                              selectedRolesArray.some(
                                item => item?.roleId === 10
                              )
                            );


                          konsole.log(
                            "selectedRolesArray",
                            selectedRolesArray,
                            findArray,
                            checkForAcadAndLpo,
                            checkForAcadLpoAndAgent
                          );


                          if (isStaffLogin) {

                            const filteredRoles =
                              selectedRolesArray.filter(
                                role =>
                                  [3, 13, 14, 15]
                                    .includes(role.roleId)
                              );


                            if (filteredRoles.length > 0) {

                              const userPswd =
                                localStorage.getItem('|\/*P*/\|');


                              const tokenKey =
                                `appState=${appState}` +
                                `&userId=${userId}` +
                                `&roleId=${JSON.stringify(filteredRoles[0]?.roleId)}` +
                                `&loggenInId=${loggenInId}` +
                                `&Psw=${userPswd}` +
                                `&legalStaff=${true}`;


                              window.location.replace(
                                `${AoIntakeBaseUrl}login?token=${window.btoa(tokenKey)}`
                              );

                            } else {

                              return;
                            }

                          }

                          else if (
                            checkForAcadAndLpo === true ||
                            checkForAcadLpoAndAgent === true ||
                            checkForLpoAndAgent === true
                          ) {

                            const redirectToLpoOrIntake =
                              selectedRolesArray?.filter(
                                item =>
                                  item?.roleId === 9 ||
                                  item?.roleId === 1 ||
                                  item?.roleId === 10
                              );


                            const userPswd =
                              localStorage.getItem('|\/*P*/\|');


                            const tokenKey =
                              `appState=${appState}` +
                              `&userId=${userId}` +
                              `&roleId=${JSON.stringify(redirectToLpoOrIntake[0]?.roleId)}` +
                              `&loggenInId=${loggenInId}` +
                              `&Psw=${userPswd}`;


                            window.location.replace(
                              `${AoIntakeBaseUrl}login?token=${window.btoa(tokenKey)}`
                            );

                          }

                          else {

                            const filteredRoles =
                              response.data.data?.userRoles.filter(
                                role =>
                                  [3, 13, 14, 15]
                                    .includes(role.roleId)
                              );


                            if (
                              findArray.length > 0 ||
                              filteredRoles.length > 0
                            ) {

                              if (
                                findArray?.some(
                                  data =>
                                    data.roleId === 23
                                )
                              ) {

                                const finalRoleId =
                                  JSON.stringify(
                                    findArray.filter(
                                      item =>
                                        item?.roleId === 23
                                    )
                                  );


                                const tokenKey =
                                  `appState=${appState}` +
                                  `&userId=${userId}` +
                                  `&roleId=${finalRoleId}` +
                                  `&loggenInId=${loggenInId}`;


                                commonLib.redirectToModule(
                                  23,
                                  tokenKey
                                );

                                return;
                              }


                              setLoaderscreenmodal(false);

                              setcurMainImageNum(2);


                              navigate(
                                `/Account/SelectRoles`,
                                {
                                  state: {
                                    selectedRolesData:
                                      json
                                  },
                                  replace: true
                                }
                              );

                            } else {

                              const userPswd =
                                localStorage.getItem('|\/*P*/\|');


                              const tokenKey =
                                `appState=${appState}` +
                                `&userId=${userId}` +
                                `&roleId=${JSON.stringify(selectedRolesArray)}` +
                                `&loggenInId=${loggenInId}` +
                                `&Psw=${userPswd}`;


                              window.location.replace(
                                `${AoPartnerBaseUrl}login?token=${window.btoa(tokenKey)}`
                              );
                            }
                          }
                        }

                      }

                    }, 500);

                  }

                  else if (errorData) {

                    setLoader(false);

                    setLoaderText('');

                  }

                }
              );

            }, 500);

          }, 500);

        });

      }, 500);

    });

  }, 300);
};


  /*
   * Browser IP helper.
   */
  const getCountryIpCode = async (callback) => {

    try {

      const url =
        "https://geolocation-db.com/json/";

      const data =
        await fetch(url);

      const parsedData =
        await data.json();

      setLoader(false);

      konsole.log(
        "dattaa",
        parsedData
      );

      callback(
        parsedData.IPv4
      );

    } catch (error) {

      console.error(
        "IP lookup failed",
        error
      );
    }
  };


  /*
   * Device detection.
   */
  const getDeviceType = (callback) => {

    const ua =
      navigator.userAgent;


    konsole.log(
      'ua',
      ua
    );


    if (
      /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)
    ) {

      return callback("tablet");
    }


    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/
        .test(ua)
    ) {

      return callback("mobile");
    }


    return callback("desktop");
  };


  /*
   * Browser detection.
   */
  const detectBrowser = (callback) => {

    const userAgent =
      navigator.userAgent;


    if (
      userAgent.indexOf("Opera") !== -1 ||
      userAgent.indexOf('OPR') !== -1
    ) {

      return callback('Opera');

    } else if (
      userAgent.indexOf("Edg") !== -1
    ) {

      return callback('Edge');

    } else if (
      userAgent.indexOf("Chrome") !== -1 &&
      userAgent.indexOf("Safari") !== -1
    ) {

      return callback('Chrome');

    } else if (
      userAgent.indexOf("Safari") !== -1 &&
      userAgent.indexOf("Chrome") === -1
    ) {

      return callback('Safari');

    } else if (
      userAgent.indexOf("Firefox") !== -1
    ) {

      return callback('Firefox');

    } else if (
      userAgent.indexOf("MSIE") !== -1 ||
      !!document.documentMode === true
    ) {

      return callback('IE');

    } else {

      return callback('Unknown');
    }
  };


  const redirectTOLogin = () => {

    navigate(`/Account/SignIn`);

  };



  const decodeJwtPayload = (token) => {
    try {
      const base64Url = token.split(".")[1];

      const base64 = base64Url
        .replace(/-/g, "+")
        .replace(/_/g, "/");

      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(
            (c) =>
              "%" +
              ("00" + c.charCodeAt(0).toString(16)).slice(-2)
          )
          .join("")
      );

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("JWT decode error:", error);
      return null;
    }
  };


  return (
    <>

      <div
        className="d-flex flex-column w-100"
        style={{
          minHeight: 'calc(-32px + 100vh)'
        }}
      >

        {
          showModal === true &&
          showModalMsgType !== null &&
          <div
            className="alert alert-info position-fixed top-0 end-0 m-5 text-white border-0"
            style={{
              width: '90%',
              maxWidth: '430px',
              backgroundColor: 'rgba(114,12,32)',
              zIndex: 99999
            }}
          >

            {
              showModalMsgType === 1 ?

                <div className='fs-5'>

                  <p className="mb-0">
                    Your privacy policy is blocking our website to proceed.
                  </p>

                  <hr />

                  <p>
                    Please change the privacy setting as per the steps below.
                  </p>

                  <p>
                    Go to Preferences {'->'} Privacy
                  </p>

                  <p>
                    Here you will see website tracking.
                    Please uncheck the checkbox and refresh.
                  </p>

                </div>

                :

                showModalMsgType === 2 ?

                  <div className='fs-5'>

                    <p className="mb-0">
                      It seems that your browser's privacy settings,
                      specifically third-party cookies, are interfering
                      with our website's functionality.
                    </p>

                    <hr />

                    <p>
                      To resolve this issue, please adjust your browser
                      settings by following these steps:
                    </p>

                    <ul>

                      <li>
                        Open <strong>{browserName}</strong> settings.
                      </li>

                      <li>
                        Set <strong>{browserName}</strong> as your default browser.
                      </li>

                      <li>
                        Go to <strong>Default App</strong> and open Settings.
                      </li>

                      <li>
                        Select <strong>Privacy & Security</strong>.
                      </li>

                      <li>
                        Ensure that the
                        <strong>
                          Allow Cross-Site Tracking (Third-Party Cookies)
                        </strong>
                        option is
                        <strong>
                          Allow all cookies.
                        </strong>
                      </li>

                    </ul>

                  </div>

                  :

                  showModalMsgType === 3 ?

                    <div>

                      <p className="mb-0">
                        Your privacy policy is blocking our website to proceed.
                      </p>

                      <hr />

                      <p>
                        Please change the privacy setting as per the steps below.
                      </p>

                      <p>
                        Go to Settings {'->'}
                      </p>

                      <p>
                        Click on Safari
                      </p>

                      <p>
                        Privacy & Security
                      </p>

                      <p>
                        Turn the toggle
                        'Prevent Cross-Site Tracking' to 'Off'
                      </p>

                    </div>

                    :

                    showModalMsgType === 4 ?

                      <div className='fs-5'>

                        <p className="mb-0">
                          It seems that your browser's privacy settings,
                          specifically third-party cookies, are interfering
                          with our website's functionality.
                        </p>

                        <hr />

                        <p>
                          To resolve this issue, please adjust your browser
                          settings by following these steps:
                        </p>

                        <ul>

                          <li>
                            Open browser's settings.
                          </li>

                          <li>
                            Select
                            <strong>
                              Privacy & Security
                            </strong>
                          </li>

                          <li>
                            Ensure that the
                            <strong>
                              Allow Cross-Site Tracking
                              (Third-Party Cookies)
                            </strong>
                            option is
                            <strong>
                              Allow all cookies.
                            </strong>
                          </li>

                        </ul>

                      </div>

                      :

                      ""
            }

          </div>
        }


        {
          isStaffLogin === true &&
          filteredAllRoles.length === 0

            ?

            <>

              <div
                className='desc'
                style={{
                  position: "absolute",
                  top: "40%"
                }}
              >

                <p className='title text-center'>
                  You are not staff; try using the button below.
                </p>

                <div className="label-input me-2">

                  <button
                    type="submit"
                    onClick={redirectTOLogin}
                  >
                    Go to the Universal Login
                  </button>

                </div>

              </div>

            </>

            :

            <>

              <LoaderScreen
                checkingconnection={checkingconnection}
                validateUserId={validateUserId}
                validateAuth0={validateAuth0}
                checkingmultirole={checkingmultirole}
                validaetsuccessfully={validaetsuccessfully}
              />

            </>
        }

      </div>

    </>
  );
}


export default Redirect;